BaseModel = require './base_model.coffee'

class global.ContactEvent extends BaseModel
  @ATTRIBUTES = {
    id: {}
    detailed_type: {}
    title: {}
    description: {}
    created_at: { type: Date }
    updated_at: { type: Date }
    email: {}
    author: {}
    edition_author: {}
    comment: {}
    flow_action_id: {}
    call_status: {}
    call_recording_url: {}
    showEmail: false
    metadata: {}
  }

  @ASSOCIATIONS = {
    user: -> User
    contact: -> Contact
    task: -> Task
    flow: -> Flow
  }

  quotedDescription: ->
    if @description && !@isCallEvent() then "\"#{@description}\"" else ''

  type: ->
    @detailed_type.split('-')[0]

  detail: ->
    @detailed_type.split('-')[1]

  emailIconClasses: ->
    unless @detail() == 'soft_bounce'
      if @detail() == 'sent'
        "task-icon #{@emailSubiconClass()}"
      else
        "email-icon contact-event-subicon #{@emailSubiconClass()}"
    else
      "soft_bounce-event-icon"

  emailSubiconClass: ->
    switch @detail()
      when 'sent' then 'email-task-icon'
      when 'delivery' then 'delivery-icon'
      when 'open' then 'open-icon'
      when 'reply' then 'reply-icon'
      when 'bounce' then 'bounce-icon'

  humanStatus: ->
    switch @call_status
      when "no_connection" then "Sem conexão"
      when "gatekeeper" then "Gatekeeper"
      when "opportunity" then "Conectado"
      when "client" then "Cliente"
      when "lost" then "Perdido"

  isDoneTaskEvent: ->
    @task && @task.done_at && !@description

  isCallEvent: ->
    @type() == 'CallEvent'



// WEBPACK FOOTER //
// ./src/models/contact_event.coffee